import { SupportedLanguage } from '../constants'

export default function isAppSupportedLanguage(language: string) {
  const supportedLanguageCodes = Object.values(SupportedLanguage)

  return supportedLanguageCodes.includes(language)
}
